<template>
    <v-dialog
        v-model="$store.state.concil.reports.StmtSumRepByStmt"
        transition="dialog-bottom-transition"
        persistent
        width="1800"
    >
        <v-container 
            fluid
            style="padding: 0;overflow: hidden;"
        >
            <v-card>
                <v-toolbar dark color="secondary" dense style="margin-bottom: 15px;">
                    <v-btn
                        icon
                        dark
                        @click="getReport('xlsx')"
                    >
                        <v-icon>mdi-microsoft-excel</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        dark
                        @click="getReport('pdf')"
                    >
                        <v-icon>mdi-file-pdf-box</v-icon>
                    </v-btn>
                    <v-switch
                        v-model="showDetVersion"
                        inset
                        label="See detailed version"
                        hide-details
                        style="margin-left: 15px;"
                    ></v-switch>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text">
                        {{ ReportData.Params.Report.Name }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <div style="width: 198px;height: 50px;margin-right: 15px;"></div>
                    <div style="width: 48px;height: 48px;"></div>
                    <v-btn
                        icon
                        dark
                        @click="$store.state.concil.reports.StmtSumRepByStmt = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-row style="padding: 10px 20px 30px;">
                    <v-col 
                        cols="12" 
                        v-if="render" 
                        style="display: flex;flex-direction: column;gap: 20px;justify-content: center;"
                    >
                        <div style="display: flex;align-items: center;">
                            <h2 style="margin: 10px;flex: 1;">Document: {{ ReportData.Params.File.FilenameCode }}</h2>
                            <table style="flex: 1;">
                                <tr>
                                    <th>PmtTotal</th>
                                    <th>UptTotal</th>
                                    <th>Diff</th>
                                </tr>
                                <tr></tr>
                                <tr>
                                    <td style="font-weight: 700;font-size: medium;text-align: center;">{{ fmtReportData.Data.OverallTotals[0].PmtTotal }}</td>
                                    <td style="font-weight: 700;font-size: medium;text-align: center;">{{ fmtReportData.Data.OverallTotals[0].UptTotal }}</td>
                                    <td style="font-weight: 700;font-size: medium;text-align: center;">{{ fmtReportData.Data.OverallTotals[0].Diff }}</td>
                                </tr>
                            </table>
                        </div>
                        <v-divider></v-divider>
                        <v-card
                            v-for="(group, i) in getVersionData()"
                            :key="i"
                        >
                            <div style="padding-top: 10px;">
                                <v-card-title>
                                    {{ group.Type }}
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="search[group.Type]"
                                        append-icon="mdi-magnify"
                                        label="Search here"
                                        hide-details
                                        style="padding: 0;margin: 0;"
                                    ></v-text-field>
                                </v-card-title>
                                <v-data-table
                                    :headers="getHeaders('vue')"
                                    :items="group.Payments"
                                    dense
                                    fixed-header
                                    :search="search[group.Type]"
                                >
                                    <template slot="body.append" v-if="group.Payments.length">
                                        <tr>
                                            <template
                                                v-for="(hd, hidx) in getHeaders('vue')"
                                            >
                                                <td
                                                    v-if="group[hd.value]"
                                                    class="text-left font-weight-bold"
                                                    :key="hidx"
                                                >
                                                    {{ group[hd.value] }}
                                                </td>
                                                <td :key="`empty-${hidx}`" v-else></td>
                                            </template>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </div>
                            <!--<v-row>
                                <v-col
                                    cols="4" 
                                    v-for="(group, i) in (showDetVersion ? fmtReportData.Data.Detailed : fmtReportData.Data.Brief)"
                                    :key="i"
                                >
                                    <v-card outlined style="padding-top: 10px;">
                                        <v-card-title>
                                            {{ group.Type }}
                                            <v-spacer></v-spacer>
                                            <v-text-field
                                                v-model="search[group.Type]"
                                                append-icon="mdi-magnify"
                                                label="Search here"
                                                hide-details
                                                style="padding: 0;margin: 0;"
                                            ></v-text-field>
                                        </v-card-title>
                                        <v-data-table
                                            :headers="showDetVersion ? detailedHeaders : briefHeaders"
                                            :items="group.Payments"
                                            dense
                                            fixed-header
                                            :search="search[group.Type]"
                                        >
                                            <template slot="body.append" v-if="group.Payments.length">
                                                <tr>
                                                    <td :colspan="showDetVersion ? 2 : 1"></td>
                                                    <td class="text-left font-weight-bold">{{ group.UptTotal }}</td>
                                                    <td class="text-left font-weight-bold">{{ group.PmtTotal }}</td>
                                                    <td class="text-left font-weight-bold">{{ group.Diff }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-card>
                                </v-col>
                            </v-row>-->
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
    </v-dialog>
</template>

<script>
import axios from "axios";
//import * as XLSX from 'xlsx';

export default {
    props: ['ReportData'],
    components: {

    },
    data: function () {
        return {
            search: {
                NonConciliated: '',
                Matched: '',
                UnMatched: '',
            },
            showDetVersion: false,
            filename: '',
            render: false,
            fmtReportData: {}
        }
    },
    mounted() {
        this.prepareData();
    },
    methods: {
        prepareData: function () {
            // Convert payments array
            for (let version in this.ReportData.Data.Versions) {
                this.ReportData.Data.Versions[version].Data.forEach(group => {
                    group.Payments = JSON.parse(group.Payments);
                });
            }

            // Verifies that the group exists
            let groups = ['NonConciliated', 'Matched', 'UnMatched'];
            for(let version in this.ReportData.Data.Versions) {
                let types = [];
                this.ReportData.Data.Versions[version].Data.forEach(group => {
                    types.push(group.Type);
                });

                groups.forEach(grp => {
                    let idx = types.indexOf(grp);
                    if (idx === -1) {
                        this.ReportData.Data.Versions[version].Data.push({
                            Type: grp,
                            Payments: [],
                        });
                    }
                });
            }

            // Sort groups
            for (let version in this.ReportData.Data.Versions) {
                this.ReportData.Data.Versions[version].Data.sort(function(a, b) {
                    let sort = ['NonConciliated', 'Matched', 'UnMatched'];
                    return sort.indexOf(a.Type) - sort.indexOf(b.Type);
                });
            }

            console.log(this.ReportData.Data);
            this.formatData();
        },
        formatData: function () {
            this.fmtReportData = JSON.parse(JSON.stringify(this.ReportData));
            let cad = new Intl.NumberFormat('en-CA', {
                style: 'currency',
                currency: 'CAD',
            });

            for (let version in this.fmtReportData.Data.Versions) {
                this.fmtReportData.Data.Versions[version].Data.forEach(group => {
                    if (group.Payments.length) {
                        group.UptTotal = cad.format(group.UptTotal);
                        group.PmtTotal = cad.format(group.PmtTotal);
                        group.Diff = cad.format(group.Diff);
                        group.Payments.forEach(pmt => {
                            pmt.UptTotal = cad.format(pmt.UptTotal);
                            pmt.PmtTotal = cad.format(pmt.PmtTotal);
                            pmt.Diff = cad.format(pmt.Diff);
                        });
                    }
                });
            }

            for (let total of this.fmtReportData.Data.OverallTotals) {
                total.UptTotal = cad.format(total.UptTotal);
                total.PmtTotal = cad.format(total.PmtTotal);
                total.Diff = cad.format(total.Diff);
            }

            // Sort groups
            for (let version in this.fmtReportData.Data.Versions) {
                this.fmtReportData.Data.Versions[version].Data.sort(function(a, b) {
                    let sort = ['NonConciliated', 'Matched', 'UnMatched'];
                    return sort.indexOf(a.Type) - sort.indexOf(b.Type);
                });
            }

            console.log(this.fmtReportData);
            this.render = true;
        },
        setParams: function (requestType) {
            // Set doc headers and data
            let headers = this.getHeaders(requestType);
            let data = [];
            let overallTotals = [];
            if (requestType == 'xlsx' && this.showDetVersion) {
                data = this.ReportData.Data.Versions.Detailed.Data;
                overallTotals = this.ReportData.Data.OverallTotals;
            } else if (requestType == 'xlsx' && !this.showDetVersion) {
                data = this.ReportData.Data.Versions.Brief.Data;
                overallTotals = this.ReportData.Data.OverallTotals;
            } else if (requestType == 'pdf' && this.showDetVersion) {
                data = this.fmtReportData.Data.Versions.Detailed.Data;
                overallTotals = this.fmtReportData.Data.OverallTotals;
            } else if (requestType == 'pdf' && !this.showDetVersion) {
                data = this.fmtReportData.Data.Versions.Brief.Data;
                overallTotals = this.fmtReportData.Data.OverallTotals;
            }

            let params = {
                Customer: this.ReportData.Params.Customer,
                Report: this.ReportData.Params.Report,
                SearchBy: this.ReportData.Params.SearchBy,
                Data: data,
                Headers: headers,
                OverallTotals: overallTotals,
            };

            if (this.ReportData.Params.SearchBy == 'date-range') {
                this.filename = "Rec_" + this.ReportData.Params.Customer.Alias + "_" + this.ReportData.Params.Report.Alias + "_" + this.ReportData.Params.StartDate + "_" + this.ReportData.Params.EndDate;
                params.StartDate = this.ReportData.Params.StartDate;
                params.EndDate = this.ReportData.Params.EndDate;
            } else if (this.ReportData.Params.SearchBy == 'file') {
                this.filename = "Rec_" + this.ReportData.Params.Customer.Alias + "_" + this.ReportData.Params.Report.Alias;
                params.File = this.ReportData.Params.File;
            }

            this.filename = this.showDetVersion ? this.filename + "_Detailed." + requestType : this.filename + "." + requestType;
            params.Filename = this.filename;

            console.log(params);
            return params;
        },
        getReport: async function (requestType) {
            let str = this.$store;
            str.state.isLoading = true;
            let params = this.setParams(requestType);
            console.log(params);
            await axios
                .post('conciliation/get/report/' + requestType, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    },
                    responseType: 'blob',
                })
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        getHeaders: function (type) {
            if (this.showDetVersion) {
                return this.ReportData.Data.Versions.Detailed.Headers[type];
            } else {
                return this.ReportData.Data.Versions.Brief.Headers[type];
            }
        },
        getVersionData: function () {
            if (this.showDetVersion) {
                return this.fmtReportData.Data.Versions.Detailed.Data;
            } else {
                return this.fmtReportData.Data.Versions.Brief.Data;
            }
        }
    },
};
</script>

<style>
    .general-tbl {
      border-collapse: collapse;
      width: 100%;
    }
    .general-tbl th, .general-tbl td {
      border: 1px solid #dddddd;
      padding: 3px 8px;
      text-align: left;
    }
    .general-tbl th {
        font-size: 12px;
    }
    .general-tbl th:hover {
        background-color: #7892b1;
    }
    .general-tbl td:hover {
        background-color: #e1e1e1;
    }
    .header-title {
        background-color: #01579b;
        color: #fefeff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        padding: 3px 0 3px 15px;
        font-weight: normal;
        font-size: 20px;
        text-align: center;
    }
    .theme--dark.v-label {
        color: hsla(0,0%,100%,.7)!important;
    }
    .theme--light.v-label {
        color: rgba(0,0,0,.6)!important;
    }
</style>